import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

import useForm, { Form } from "../../../../hooks/useForm";
import Controls from "../../../../components/form/controls/Controls";
import GridSelectPermission from "../../../../components/GridSelectPermission/GridSelectPermission";
import useSelectPermission from "../../../../hooks/useSelectPermission";
import Popup from "../../../../components/popup/Popup";
import { useHistory, useParams } from "react-router-dom";
import { validationEmployeeInput } from "../../../../utils";
import {
  getDepartmentDetail,
  getDepartments,
} from "../../../../apis/System/department.api";
import {
  createEmployee,
  getDetailEmployee,
  moveDepartment,
  updateEmployee,
} from "../../../../apis/System/employee.api";
import { getDetailRole } from "../../../../apis/System/role.api";
import { path } from "../../../../constants/path";

const genderItems = [
  { id: "male", title: "Male" },
  { id: "female", title: "Female" },
  { id: "other", title: "Other" },
];

const initialValue = {
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  address: "",
  phone: "",
  salary: "",
  birthDay: new Date(),
  gender: "male",
  departmentId: "",
  roleId: "",
  permissionIds: [],
};

const NoteText = () => {
  return (
    <div
      style={{
        color: "red",
        fontSize: "16px",
        marginBottom: "10px",
      }}
    >
      <span>
        *** <i className="bx bxs-check-square" style={{ color: "gray" }}></i>
        {": "}
        permission của role. không thể chỉnh sửa !!!
      </span>
    </div>
  );
};

function EmployeeAction() {
  let { id } = useParams();
  const history = useHistory();
  const [listPermissionOfRole, setListPermissionOfRole] = useState([]);
  const [createAnother, setCreateAnother] = useState(false);
  const { checked, setChecked } = useSelectPermission([]);
  const [departments, setDepartments] = useState([]);
  const [roles, setRoles] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  // validation input employee
  const validateEmployeeForm = (fieldValues = values) => {
    let temp = validationEmployeeInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateEmployeeForm);

  useEffect(() => {
    // * Get list department
    getDepartments({ page: 1, limit: 1000 }, (result) => {
      setDepartments([...result.list]);
    });
  }, []);

  useEffect(() => {
    if (values.departmentId) {
      getDepartmentDetail(values.departmentId, (result) => {
        setRoles(result.roles);
        if (id) {
          setValues({
            ...values,
            password: "",
          });
        } else {
          setValues({
            ...values,
            password: "",
            roleId: result.roles[0].id,
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.departmentId]);

  useEffect(() => {
    if (id) {
      getDetailEmployee(id, (result) => {
        const roleId = result.roles[0]?.id;

        // * maps permission id of employee
        setChecked(result.permissions.map((permissions) => permissions.id));

        // * set State
        setValues({
          ...values,
          id: result.id,
          firstName: result.firstName,
          lastName: result.lastName,
          email: result.email,
          address: result.address,
          phone: result.phone,
          salary: result.salary,
          birthDay: result.birthDay,
          gender: result.gender,
          departmentId: result.departmentId,
          roleId: roleId,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (values.roleId) {
      getDetailRole(values.roleId, (result) => {
        setListPermissionOfRole(
          result.permissions.map((permissions) => permissions.id)
        );
      });
    }
  }, [values.roleId]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateEmployeeForm()) {
      // * Lọc các permissionId không trùng với listPermissionOfRole
      const listPermissionExtra = checked.filter(
        (permissionId) => !listPermissionOfRole.includes(permissionId)
      );

      // * tạo data gọi api (tạo nhân viên, cập nhật nhân viên).
      const data = { ...values, permissionIds: listPermissionExtra };

      if (id) {
        let dataMoveRole = {
          employeeId: data.id,
          departmentId: data.departmentId,
          roleId: data.roleId,
          permissionIds: data.permissionIds,
        };
        moveDepartment(dataMoveRole, () => {
          updateEmployee(data.id, data, (result) => {
            // callback nhận về lỗi form và thành công
            if (result.data?.status === 422) {
              setErrors({ ...result.data.data });
            } else {
              history.push(`${path.systemEmployee}`);
            }
          });
        });
      } else {
        createEmployee(data, (result) => {
          // callback nhận về lỗi form và thành công
          if (result.data?.status === 422) {
            setErrors({ ...result.data.data });
          } else {
            if (createAnother) {
              resetForm();
            } else {
              history.push(`${path.systemEmployee}`);
            }
          }
        });
      }
      setListPermissionOfRole([]);
      setChecked([]);
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Grid container>
        <Grid item xs={6} p={5}>
          <Controls.Input
            name="firstName"
            value={values.firstName}
            label="First name"
            type="text"
            onChange={handleInputChange}
            error={errors.firstName}
          />
          <Controls.Input
            name="lastName"
            value={values.lastName}
            label="Last name"
            type="text"
            onChange={handleInputChange}
            error={errors.lastName}
          />
          <Controls.Input
            name="email"
            value={values.email}
            label="Email"
            type="email"
            disabled={id ? true : false}
            onChange={handleInputChange}
            error={errors.email}
          />

          <Controls.Input
            name="address"
            value={values.address}
            label="Address"
            onChange={handleInputChange}
            error={errors.address}
          />
        </Grid>
        <Grid item xs={6} p={5}>
          <Controls.Input
            name="phone"
            value={values.phone}
            label="Phone"
            onChange={handleInputChange}
            error={errors.phone}
          />
          <Controls.Input
            name="salary"
            value={values.salary}
            label="Salary"
            onChange={handleInputChange}
            error={errors.salary}
          />
          {values.departmentId !== null ? (
            <Controls.Select
              name="departmentId"
              label="Department"
              value={values.departmentId}
              onChange={handleInputChange}
              options={departments}
              searchable={true}
              error={errors.departmentId}
            />
          ) : null}
          {values.departmentId ? (
            <Controls.Select
              name="roleId"
              label="Role"
              value={values.roleId}
              onChange={handleInputChange}
              options={roles}
              searchable={true}
              error={errors.roleId}
            />
          ) : null}
          <Controls.Button
            text="Add More Permission"
            sx={{ width: "100%", margin: "10px 0" }}
            onClick={() => setOpenPopup(true)}
          />
          <Popup
            title={"Permission Extra"}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            sx={{
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "100%",
                  maxWidth: "1200px", // Set your width here
                },
              },
            }}
          >
            <>
              {listPermissionOfRole.length ? <NoteText /> : null}
              <GridSelectPermission
                checked={checked}
                setChecked={setChecked}
                listPermissionOfRole={listPermissionOfRole}
              />
              <Controls.Button
                onClick={() => setOpenPopup(false)}
                text="Apply"
                sx={{ width: "100%", margin: "10px 0" }}
              />
            </>
          </Popup>
          <Controls.RadioGroup
            name="gender"
            label="Gender"
            value={values.gender}
            onChange={handleInputChange}
            items={genderItems}
          />

          {!id ? (
            <Controls.Checkbox
              name="createAnother"
              label="Create another"
              value={createAnother}
              onChange={() => setCreateAnother(!createAnother)}
            />
          ) : null}

          <div style={{ marginTop: "10px" }}>
            <Controls.Button type="submit" text="Submit" />
            <Controls.Button text="Reset" color="inherit" onClick={resetForm} />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}

export default EmployeeAction;
